module.exports = __webpack_public_path__ + "static/media/38.a831ba9a.gif";